export const formatRouteDate = (dateStr: string | null): string | null => {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return null;
  return `${date.getMonth() + 1}/${date.getDate()}`;
};

export const formatTransportRouteInfo = (
  origin: string | null,
  destination: string | null,
  departureDate: string | null
): string => {
  const route = origin && destination ? `${origin} → ${destination}` : '';
  const date = formatRouteDate(departureDate);
  const dateStr = date ? `（${date}）` : '';
  return route || dateStr ? `：${route}${dateStr}` : '';
};

export const formatHotelLocationInfo = (destination: string | null, departureDate: string | null): string => {
  const location = destination || '';
  const date = formatRouteDate(departureDate);
  const dateStr = date ? `（${date}）` : '';
  return location || dateStr ? `：${location}${dateStr}` : '';
};
